import { NavLink } from "react-router-dom"
import style from "./CustomNavLink.module.scss"

const { customNavLink } = style

type Props = { to: string; className?: string; children: React.ReactNode }

export const CustomNavLink = ({ to, children, className = "" }: Props) => {
	return (
		<NavLink to={to} className={`${customNavLink} ${className}`}>
			{children}
		</NavLink>
	)
}
